import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from 'styled-components';

const IconDiv = styled.div`
`

const UkIcon = ({width}) => { 
  const icon = useStaticQuery(graphql`
    query {
      ukIcon: file(relativePath: { eq: "uk.png" }) {
        childImageSharp {
          fixed(width: 25, , quality: 10) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
  return (
    <IconDiv style={{width: `${width}px`}}>
        <Img fixed={icon.ukIcon.childImageSharp.fixed} />
    </IconDiv>
  )
}


export default UkIcon
